import { UserState } from "@/store/interfaces/user";

export const state: UserState = {
  user: {
    status: false,
    didInvalidate: false,
    receivedAt: 0,
    connectionError: false,
    user: {}
  },
  passwordReset: {
    status: false,
    didInvalidate: false,
    receivedAt: 0,
    connectionError: false
  },
  register: {
    status: false,
    didInvalidate: false,
    receivedAt: 0,
    flowState: "base",
    email: "",
    error: false
  },
  registerValidation: {
    status: false,
    didInvalidate: false,
    receivedAt: 0,
    connectionError: false,
    response: {}
  }
};
